"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM_HEADER_NAME = exports.PLATFORM_ACCESS_DENIED_CODE = exports.BusinessPlatform = void 0;
var BusinessPlatform;
(function (BusinessPlatform) {
    BusinessPlatform["HANDSHAKE"] = "handshake";
    BusinessPlatform["NUCLEUS"] = "nucleus";
})(BusinessPlatform || (exports.BusinessPlatform = BusinessPlatform = {}));
exports.PLATFORM_ACCESS_DENIED_CODE = "PLATFORM_ACCESS_DENIED";
exports.PLATFORM_HEADER_NAME = "x-platform";
